import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import awsExports from './aws-exports';
import { Hub } from '@aws-amplify/core';
import { StrictMode } from 'react';
import { Amplify } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub';
import App from './App';
import './index.css';

Amplify.configure(awsExports);
Amplify.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region:    'us-east-1',
    aws_pubsub_endpoint:  'wss://ag3lxmk29btzg-ats.iot.us-east-1.amazonaws.com/mqtt',
  })
);

// Subscribe to MQTT messages
Hub.listen('pubsub', ({ payload }) => {
  console.log('HUB event:', payload);
});

//<StrictMode><App /> </StrictMode>
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>

<App />
  </StrictMode>
    
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
